<template>
	<v-container>
		<v-dialog v-model="showDialog" scrollable persistent max-width="1150px">
			<v-skeleton-loader v-if="loading" type="article, actions"></v-skeleton-loader>
			<v-card v-if="!loading" class="pt-1 elevation-0">
				<v-card-title class="py-2">
					<h3 v-if="currentStep === 0" class="black--text">
						{{ $t('wkt.admin.license.upgrade-account-window.step-1.title') }}
					</h3>
					<h3 v-if="currentStep === 1" class="black--text">
						{{ $t('wkt.admin.license.upgrade-account-window.step-2.title') }}
					</h3>
					<h3 v-if="currentStep === 2 && upgrade" class="black--text">
						{{ $t('wkt.admin.license.upgrade-account-window.step-3.upgrade_title') }}
					</h3>
					<h3 v-if="currentStep === 2 && !upgrade" class="black--text">
						{{ $t('wkt.admin.license.upgrade-account-window.step-3.renew_title') }}
					</h3>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text v-if="!loading" class="py-0">
					<UpgradePlanStep1 
						v-if="!loading && currentStep === 0" 
						:company="company"
						:licensingInfo="licensingInfo"
						:licenseType="selectedType"
						:licensePlan="selectedPlan"
						@plan-changed="updateSelectedPlan($event)" 
						@type-changed="updateSelectedType($event)" />
					<UpgradePlanStep2 
						v-if="!loading && currentStep === 1" 
						:company="company"
						:licensingInfo="licensingInfo" 
						:licenseType="selectedType" 
						:licensePlan="selectedPlan" 
						:planEmployees="planEmployees"
						:planStorage="planStorage"
						:planSignatures="planSignatures"
						:upgrade="upgrade"
						@employees-changed="updatePlanEmployees($event)" 
						@storage-changed="updatePlanStorage($event)" 
						@signatures-changed="updatePlanSignatures($event)" />
					<UpgradePlanStep3 
						v-if="!loading && currentStep === 2" 
						:company="company"
						:licensingInfo="licensingInfo" 
						:licenseType="selectedType" 
						:licensePlan="selectedPlan" 
						:planEmployees="planEmployees"
						:planStorage="planStorage"
						:planSignatures="planSignatures"
						:autorenew="upgrade ? autorenew : null"
						:voucher="currentVoucher"
						:upgrade="upgrade"
						@autorenew-changed="updateAutorenew($event)" 
						@renewdate-changed="updateRenewDate($event)" 
						@add-voucher="addVoucher($event)" />
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions v-if="!loading">
					<v-btn color="#185EA9" text @click="openLicenseRates()" style="font-size: 0.9em; font-weight: 400;">
						<v-icon small color="#185EA9" class="mr-2">open_in_new</v-icon>
						<span class="text-decoration-underline">{{ $t('wkt.admin.license.upgrade-account-window.step-1.more_info').toUpperCase() }}</span>
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn v-if="currentStep < 2" color="#185EA9" text @click="updateStep(currentStep + 1)" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.next').toUpperCase() }}</v-btn>
					<v-btn v-if="currentStep === 2" color="#185EA9" text @click="processPurchaseOrder()" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.continue').toUpperCase() }}</v-btn>
					<v-btn text @click="close()" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.cancel').toUpperCase() }}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-snackbar
			v-model="showAlert"
			:timeout="alertTimeout"
			:color="alertColor">
				<span style="color: #ffffff;">{{alertText}}</span>
				<v-btn text @click="showAlert=false">
				<span style="color: #ffffff;">{{$t('wkt.admin.common.dialog-buttons.close')}}</span>
				</v-btn>
		</v-snackbar>
	</v-container>
</template>

<script>
import BaseModule from '../../../common/BaseModule.js';
import PurchaseUtils from './PurchaseUtils.js';
import UpgradePlanStep1 from './UpgradePlanStep1';
import UpgradePlanStep2 from './UpgradePlanStep2';
import UpgradePlanStep3 from './UpgradePlanStep3';
import api from '../../../../api/worktime.js';
import gwt from '../../../../api/gwt.js';

export default {
    name: 'UpgradeLicenseDialog',
    mixins: [BaseModule, PurchaseUtils],
	components: {
		UpgradePlanStep1, UpgradePlanStep2, UpgradePlanStep3
	},
    data () {
		return {
			loading: false,
			currentStep: 0,
			company: null,
			upgrade: true,
			selectedType: null,
			selectedPlan: null,
			licensingInfo: null,
			planEmployees: 0,
			planStorage: 0, 
			planSignatures: 0,
			currentVoucher: null,		
			autorenew: false,
			renewDate: null,
			showAlert: false,
			alertColor: 'error',
			alertText: '',
			alertTimeout: 3000,
			showDialog: false,
		}
    },
    methods: {
		onReveal(action) {
			this.company = action.company;
			this.upgrade = action.upgrade;
			if (this.upgrade) { 
				this.selectedType = this.company.licenseType === this.constants.LICENSE_TYPE_FREE ? 
					this.constants.LICENSE_TYPE_BUSINESS : this.constants.LICENSE_TYPE_CORPORATE;
			} else {
				this.selectedType = this.company.licenseType;
			}
			this.selectedPlan = this.company.licensePlan === this.constants.LICENSE_PLAN_MONTHLY ? 
				this.constants.LICENSE_PLAN_MONTHLY : this.constants.LICENSE_PLAN_ANNUAL;
			this.autorenew = this.company.licensePlanAutonrenew;
			
			this.currentVoucher = null;
			this.licensingInfo = null;
			
			this.planEmployees = 0;
			this.planStorage = 0;
			this.planSignatures = 0;
			
			console.log(`*** this.upgrade: ${this.upgrade}`);

			this.open();
		},
		open() {
			this.updateStep(this.upgrade ? 0 : 2);

			this.refreshLicensingInfo();
				
			this.showDialog = true;
		},
		close() {				
			this.showDialog = false;
		},		
		refreshLicensingInfo() {
			this.loading = true;

			api.getSKULicensingInfo(
				data => {
					this.loading = false;
					this.licensingInfo = data;

					if (!this.upgrade) {
						this.planEmployees = this.calculatePlanEmployees(this.company).num;
						this.planStorage = this.calculatePlanStorage(this.company, this.licensingInfo, this.selectedType, this.selectedPlan).num;
						this.planSignatures = this.calculatePlanSignatures(this.company, this.licensingInfo, this.selectedType, this.selectedPlan, 0).num;
					}
				},
				error => {
					this.loading = false;
					this.doShowAlert({ text: error, color: 'error', timeout: 3000 });
				}
			);
		},
		openLicenseRates() {			
			window.open('https://tweem.com/tarifas-tweem', '_blank');
		},
		updateStep(step) {
			this.currentStep = step;
			console.log(`**** currentStep: ${this.currentStep}`);
		},
		updateSelectedType(type) {
			this.selectedType = type;
			console.log(`**** selectedType: ${this.selectedType}`);
		},
		updateSelectedPlan(plan) {
			this.selectedPlan = plan;
			console.log(`**** selectedPlan: ${this.selectedPlan}`);
		},
		updatePlanEmployees(num) {
			this.planEmployees = num;
			console.log(`**** planEmployees: ${this.planEmployees}`);
		},
		updatePlanStorage(num) {
			this.planStorage = num;
			console.log(`**** planStorage: ${this.planStorage}`);
		},
		updatePlanSignatures(num) {
			this.planSignatures = num;
			console.log(`**** planSignatures: ${this.planSignatures}`);
		},
		updateAutorenew(value) {
			this.autorenew = value;
			console.log(`**** autorenew: ${this.autorenew}`);
		},
		updateRenewDate(date) {
			this.renewDate = date;
			console.log(`**** renewDate: ${this.renewDate.toISOString().split('T')[0]}`);
		},
		addVoucher(voucher) {
			console.log(`**** voucher added: ${voucher.code}`);
			this.currentVoucher = voucher;
			this.$emit('voucher-used', voucher);
		},
		processPurchaseOrder() {
			const po = {
				companyId: this.company.id,
				licenseType: this.selectedType,
				licensePlan: this.selectedPlan,
				//description: this.$t('wkt.admin.license.upgrade-account-window.purchase_license'),
				orderType: this.constants.ORDER_TYPE_PLAN_UPGRADE,
				autoRenew: this.autorenew,
				licenses: this.buildPurchaseOrderLicenses(),
				stock: [] //this.buildPurchaseOrderStock()				
			};

			if (this.currentVoucher) {
				po.voucherCode = this.currentVoucher.code;
			}

			this.loading = true;

			api.createPurchaseOrder(po, 
				data => {
					this.loading = false;
					this.doPayment(data);
				},
				error => {
					this.loading = false;
					this.doShowAlert({ text: error, color: 'error', timeout: 3000 });
				}
			);
		},		
		buildPurchaseOrderLicenses() {
			let licenses = [];

			// Trabajadores
			let sku = this.findLicenseSKU(this.licensingInfo, this.constants.ACTIVE_EMPLOYEES, this.selectedType, this.selectedPlan, this.constants.LICENSE_CLASS_BASE);
			//let sku = this.findLicenseSKU(this.licensingInfo, this.constants.ACTIVE_EMPLOYEES, this.constants.LICENSE_TYPE_FREE/*this.selectedType*/, this.constants.LICENSE_PLAN_ANNUAL/*this.selectedPlan*/, this.constants.LICENSE_CLASS_BASE);
			
			let planQuantity = 0;
			
			if (sku) {
				licenses.push(this.createLicenseFromSKU(sku, this.company.id, sku.quantity));
				planQuantity = sku.quantity;
			}

			if (this.planEmployees > planQuantity) {
				sku = this.findLicenseSKU(this.licensingInfo, this.constants.ACTIVE_EMPLOYEES, this.selectedType, this.selectedPlan, this.constants.LICENSE_CLASS_EXTENSION);
				licenses.push(this.createLicenseFromSKU(sku, this.company.id, this.planEmployees - planQuantity));
			}

			// Almacenamiento
			sku = this.findLicenseSKU(this.licensingInfo, this.constants.STORAGE_MB, this.selectedType, this.selectedPlan, this.constants.LICENSE_CLASS_BASE);
			
			planQuantity = 0;
			
			if (sku) {
				licenses.push(this.createLicenseFromSKU(sku, this.company.id, sku.quantity));
				planQuantity = sku.quantity;
			}

			if (this.planStorage > planQuantity) {
				sku = this.findLicenseSKU(this.licensingInfo, this.constants.STORAGE_MB, this.selectedType, this.selectedPlan, this.constants.LICENSE_CLASS_EXTENSION);
				licenses.push(this.createLicenseFromSKU(sku, this.company.id, this.planStorage - planQuantity));
			}

			return licenses;
		},
		buildPurchaseOrderStock() {
			let stock = [];

			if (!this.autorenew) {
				return stock; // En renovación no regalamos firmas
			}

			// Firmas
			let sku = this.findStockSKU(this.licensingInfo, this.constants.SMS_SIGNATURE, this.selectedType, this.selectedPlan, this.constants.LICENSE_CLASS_BASE);
			
			let planQuantity = 0;
			
			if (sku) {
				stock.push(this.createStockFromSKU(sku, this.company.id, sku.quantity));
				planQuantity = sku.quantity;
			}

			if (this.planSignatures > planQuantity) {
				sku = this.findStockSKU(this.licensingInfo, this.constants.SMS_SIGNATURE, this.selectedType, this.selectedPlan, this.constants.LICENSE_CLASS_EXTENSION);
				stock.push(this.createStockFromSKU(sku, this.company.id, this.planSignatures - planQuantity));
			}

			return stock;
		},
		doPayment(request) {
			// Se ha procesado directamente
			if (request.totalAmount === 0) {
				const payload = { 
					message: 'ok'
				};

				gwt.fireEvent('PaymentMessageEvent', JSON.stringify(payload));

				//onPurchaseCompleted(); --> LicenseQuotaUpdatedEvent.fire(this);
				//getView().onPurchaseCompleted(true);
			} else {
				const payload = { 
					title: 'wkt.admin.license.payment.confirmation.title', 
					url: `../external/payment/redirect/${request.id}`, 
					showIcon: false 
				};

				gwt.fireEvent('ShowExternalContentEvent', JSON.stringify(payload));

				//ShowExternalContentEvent.fire(this, "wkt.admin.license.payment.confirmation.title",
				//ApplicationConstants.SERVICE_URL + "../external/payment/redirect/" + request.id, false);
			}
		},
		doShowAlert(payload) {
			this.alertText = payload.text;
			this.alertColor = payload.color;
			this.alertTimeout = payload.timeout;
			this.showAlert = true;
		},
    },
}
</script>